import ContactSection from "../components/Contact/ContactSection";

export default function Contact() {
  return (
    <div className="">
      <ContactSection />
    </div>
  );
}
